import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import ReactWhatsapp from "react-whatsapp";

import Header from "../inc/Header";
import Dul21_580gm from "../images/dul21.580gm.jpg";
import Dulnew18_71gm from "../images/dul18.71gm.jpg";
import Dul23_280gm from "../images/dul23.280gm.jpg";
import Dul26_540gm from "../images/dul26.540GM.jpg";

import Dul15gm from "../images/dul15.00gm.jpg";
import Dul6_460gm from "../images/dul16.460gm.jpg";

import Dul14_690gm from "../images/dul14.690gm.jpg";
import fullkan10_090gm from "../images/Fullkan 10.090gm.jpg";
import fullkan9_980gm from "../images/Full kan 9.980gm.jpg";
import fullkan10_970gm from "../images/Full kan 10.970gm.jpg";

import fullkan11_750gm from "../images/Full kan 11_750gm.jpg";
import fullkan13_590gm from "../images/Fullkan13.590gm.jpg";
import fullkan11_530gm from "../images/Full jan 11.530gm.jpg";
import fullkan15_480gm from "../images/Full Kan 15_480gm.jpg"


import fullkan16_760gm from "../images/full16760gm.jpg";
import fullkan15_220gm from "../images/Full kan 15.220gm.jpg";
import fullkan14_410gm from "../images/Full Kan 14.410gm.jpg";
import fullkan12_890gm from "../images/full kan 12.890gm.jpg";




import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'






function Jhumkapage() {
    return (
        <div>
            
            <Header />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="maroon" />
            <div className='colorbacklockt'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Jhumka</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

          
          
   <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img id="myimage" src={Dulnew18_71gm} className="card-img-top" alt="Jhumka"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Jhumka </h5>
                                                <p className="card-text">Weight: 18.71gm</p>
                                                <p className="card-text mb-2">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul21_580gm} className="card-img-top" alt="Jhumka"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 style={{ color: "black" }} className="card-title mb-1">Jhumka</h5>
                                            <p className="card-text">Weight: 21.580gm</p>
                                            <p className="card-text mb-2">ID No..</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul23_280gm} className="card-img-top" alt="Jhumka"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1">Jhumka</h5>
                                            <p className="card-text">Weight: 23.280gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                <div className='cardmotation'>
                                    <div className="card">
                                        <Zoom>
                                            <img src={Dul26_540gm} className="card-img-top" alt="Jhumka"/>
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="card-title mb-1" >Jhumka</h5>
                                            <p className="card-text">Weight: 26.540gm</p>
                                            <p className="card-text mb-2">ID No.</p>
                                            <div className="d-flex justify-content-between align-items-center mb-0">
                                                <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={Dul14_690gm} className="card-img-top" alt="jhumka14.690gm"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "black" }} className="card-title mb-1">Jhumka </h5>
                                                <p className="card-text">Weight: 14.690gm</p>
                                                <p className="card-text">ID No.</p>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                     <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Dul15gm} className="card-img-top" alt="jhumka" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1">Jhumka</h5>
                                                <p className="card-text">Weight: 15gm</p>
                                                <p className="card-text mb-2">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                       <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Dul6_460gm} className="card-img-top" alt="jhumka" />
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 className="card-title mb-1" >Jhumka</h5>
                                                <p className="card-text">Weight: 16.460gm</p>
                                                <p className="card-text mb-2">ID No.</p>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9093168565'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9093168565" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


           





            

        
            <br />

            <br />
        </div>
    )
}

export default Jhumkapage